/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import moment from 'moment';
import {map, Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {OBJECT_TYPE} from '../../common/constants/object-type';

export class NotificationModel {
  id: string;
  time: moment.Moment;
  objectType: any;
  [key: string]: any;

  constructor(props: any) {
    _.assign(this, props);
    this.time = moment(this.time);
    this.objectType = _.get(OBJECT_TYPE, this.objectType, {stateName: '.'});
  }

  equals(other: any): boolean {
    return this.id === other?.id;
  }
}

@Injectable({providedIn: 'root'})
export class NotificationApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  query(since?: moment.MomentInput): Observable<NotificationModel[]> {
    const minDate = moment.utc().subtract(28, 'd');
    const notificationSince = moment(since).isBefore(minDate) ? minDate : since;
    return this.client.request<{results: any[]}>({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('notifications'),
      params: {
        since: moment.isMoment(notificationSince) ? notificationSince.toJSON() : notificationSince
      }
    }).pipe(map((page) => (page.results || []).map((notification) => new NotificationModel(notification))));
  }
}
